// extracted by mini-css-extract-plugin
export default {"docs_card":"Document_docs_card__iIM8K","card_img":"Document_card_img__iHt9c","row":"Document_row__N2bmb","col":"Document_col__Gx9w+"};